/*
 * orquis-buy-shade.js (2026-08-05)
 * Tints the add-to-bag button to the selected shade and keeps the price inside
 * it in sync. Colours come from the product's custom.shade_colors map (emitted
 * as a JSON string in data-shade-colors on the button). Text colour is chosen
 * per shade between the brand ink and cream by whichever gives the higher
 * contrast, so every shade stays readable. If the map or JS is absent the
 * button keeps its ink default, so the design language is unchanged.
 *
 * The button element is re-queried on every update (product-info.js may touch
 * or re-render it on variant change), and the colour is set inline so it wins.
 */
(function () {
  'use strict';
  var STAGE = '.product--orquis-stage';

  function hexToRgb(hex) {
    var c = (hex || '').trim().replace('#', '');
    if (c.length === 3) c = c.split('').map(function (x) { return x + x; }).join('');
    if (c.length < 6) return null;
    var r = parseInt(c.slice(0, 2), 16), g = parseInt(c.slice(2, 4), 16), b = parseInt(c.slice(4, 6), 16);
    return [r, g, b].some(isNaN) ? null : [r, g, b];
  }
  function tripleToRgb(t) {
    var p = (t || '').split(',').map(function (x) { return parseInt(x.trim(), 10); });
    return (p.length < 3 || p.slice(0, 3).some(isNaN)) ? null : p.slice(0, 3);
  }
  function lum(rgb) {
    var a = rgb.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  function contrast(a, b) {
    var hi = Math.max(lum(a), lum(b)), lo = Math.min(lum(a), lum(b));
    return (hi + 0.05) / (lo + 0.05);
  }

  function init(root) {
    var first = root.querySelector('.product-form__submit');
    if (!first) return;
    var map = {};
    try { map = JSON.parse(first.getAttribute('data-shade-colors') || '{}'); } catch (e) { map = {}; }
    var priceEl = root.querySelector('[id^="price-"]');
    var variantSelects = root.querySelector('variant-selects');
    var cs = getComputedStyle(document.documentElement);
    var ink = tripleToRgb(cs.getPropertyValue('--color-foreground')) || [43, 33, 28];
    var cream = tripleToRgb(cs.getPropertyValue('--color-background')) || [255, 244, 238];

    function checkedRadio() {
      return root.querySelector('.orquis-shade__input:checked') ||
        root.querySelector('variant-selects input[type="radio"]:checked');
    }
    function shadeHex() {
      var r = checkedRadio();
      if (!r) return null;
      if (map[r.value]) return map[r.value];
      var esc = (window.CSS && CSS.escape) ? CSS.escape(r.id) : r.id;
      var dot = root.querySelector('.orquis-shade__chip[for="' + esc + '"] .orquis-shade__dot') ||
        root.querySelector('.orquis-shade__chip.is-selected .orquis-shade__dot');
      var v = dot && (dot.style.getPropertyValue('--shade') || '').trim();
      return v || null;
    }
    function apply() {
      var btn = root.querySelector('.product-form__submit');
      if (!btn) return;
      // the sticky bar lives outside the product block, so it is queried from
      // the document; it takes the same shade colour as the main button.
      var targets = [btn].concat(
        Array.prototype.slice.call(document.querySelectorAll('.orquis-atc-bar__button'))
      );
      var rgb = hexToRgb(shadeHex());
      targets.forEach(function (el) {
        if (rgb) {
          var fg = contrast(rgb, cream) >= contrast(rgb, ink) ? cream : ink;
          var bgc = 'rgb(' + rgb.join(',') + ')';
          el.style.setProperty('background-color', bgc, 'important');
          el.style.setProperty('color', 'rgb(' + fg.join(',') + ')', 'important');
          el.style.setProperty('border-color', bgc, 'important');
        } else {
          ['background-color', 'color', 'border-color'].forEach(function (p) { el.style.removeProperty(p); });
        }
      });
      var amt = btn.querySelector('.orquis-buy-amt');
      if (amt && priceEl) {
        var p = priceEl.querySelector('.price-item--sale:not(.hidden), .price-item--regular, .price-item');
        var t = ((p ? p.textContent : priceEl.textContent) || '').replace(/\s+/g, ' ').trim();
        if (t) amt.textContent = t;
      }
    }

    apply();
    if (variantSelects) variantSelects.addEventListener('change', apply);
    // product-info.js re-renders parts of the block (and the price) on variant
    // change; re-apply on structural changes. childList only, so setting inline
    // style below never re-triggers this.
    var pending;
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(apply, 30);
    }).observe(root, { childList: true, subtree: true });
  }

  function boot() { document.querySelectorAll(STAGE).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
